import { TeliaCheckbox, TeliaFieldError } from '@teliads/components/react';

import './CheckboxValidationWrapper.scss';

import { CheckboxField } from 'utils/models';

type Props = {
  onChecked: (index: number, isChecked: boolean) => void;
  errorMessage: string;
  fields: CheckboxField[];
  isSubmitClicked: boolean;
  singleCheckbox?: boolean;
};

export default function CheckboxValidationWrapper({
  onChecked,
  fields,
  errorMessage,
  isSubmitClicked,
  singleCheckbox = false,
}: Props) {
  const isRequired = !fields.some((item) => item.isChecked);

  const updateAgreement = (index: number, value: boolean) => {
    onChecked(index, value);
  };
  const isErrorMessageShown = isRequired && isSubmitClicked;

  return (
    <div className="checkbox-validation-wrapper">
      <div
        className={`checkbox-validation-wrapper__checkboxes-wrapper${
          singleCheckbox ? '--single-checkbox' : ''
        }`}
      >
        {fields.map(({ name, value }, index) => (
          <TeliaCheckbox
            data-testid="validation-wrapper-checkbox"
            key={name}
            name={name}
            onInput={(e: any) => updateAgreement(index, e.target.checked)}
            value={value}
          >
            {value}
          </TeliaCheckbox>
        ))}
      </div>
      {isErrorMessageShown && (
        <TeliaFieldError
          data-testid="checkbox-validation-wrapper-error"
          className="checkbox-validation-wrapper__error"
        >
          {errorMessage}
        </TeliaFieldError>
      )}
    </div>
  );
}
